/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ShipmentMeasurement {
  BD = 0,
  EA = 1,
}
